export class HelperCollapse {
  private _isCollapsed = true;
  icon = "down-arrow";

  private setIcon() {
    this.icon = !this.isCollapsed ? "up-arrow" : "down-arrow";
  }

  toggleContent(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.isCollapsed = !this.isCollapsed;
    this.setIcon();
  }

  set isCollapsed(value: boolean) {
    this._isCollapsed = value;
    this.setIcon();
  }

  get isCollapsed(): boolean {
    return this._isCollapsed;
  }
}
